import { Component, OnInit } from '@angular/core';
import { Usuario } from '../shared';
import { UsuarioService } from '../shared/service/usuario/usuario.service';
import { LoginService } from '../shared/service/login/login.service';
import { Login } from '../shared';
import { environment } from '../../environments/environment';
import { UtilService } from '../shared/service/util/util.service';
import {appVersion} from "../app.version";

declare var $: any;

export interface FormModel {
  captcha?: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public usuario = new Login();
  public errorMessage: string;
  public emailSent: boolean = false;
  public isVarejo: boolean = false;
  public recaptchaSiteKey: string;
  public formModel: FormModel = {};
  public disabledSubmit: boolean = false;
  public showSpinner: boolean = false;

  version: string
  copyright: string;

  constructor(
    private loginService: LoginService,
    private usuarioService: UsuarioService,
    private utilService: UtilService) {

  }

  ngOnInit() {
    this.version = appVersion
    let year = new Date().getFullYear().toString();
    this.copyright = year + " @ Certisign Certificadora Digital";

    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');

    this.recaptchaSiteKey = environment.recaptchaSiteKey;

    if (localStorage.getItem('message')) {
      this.utilService.showSuccess(localStorage.getItem('message'));
      localStorage.removeItem('message');
      localStorage.removeItem('errMessage');
    } else if (localStorage.getItem('errMessage')) {
      this.utilService.showError(localStorage.getItem('errMessage'));
      localStorage.removeItem('errMessage');
    }

    if (location.host === environment.varejoHost)
      this.isVarejo = true;
  }

  login() {
    this.showSpinner = true;
    this.disabledSubmit = true;

    this.usuario.email = this.usuario.email.trim();
    this.usuario.urlAcesso = this.utilService.getSubdominio();
    this.usuario.viaWeb = true;

    this.loginService.doLogin(this.usuario).then(
      () => {
        this.showSpinner = false;
      }).catch(() => {
        this.showSpinner = false;
        this.disabledSubmit = false;
      });
  }

  recuperarSenha() {
    this.usuario.email = this.usuario.email.trim();
    this.usuario.urlAcesso = this.utilService.getSubdominio();

    this.usuarioService.solicitarResetSenha(this.usuario).subscribe(
      res => {
        this.errorMessage = null;
        $('#modalRecuperarSenha').modal('toggle');
        this.utilService.showSuccess(res.message);
        this.emailSent = true;
      },
      err => {
        this.errorMessage = err.message;
      }
    );
  }

  reenviarEmail() {
    const usr = new Usuario();
    this.usuario.email = this.usuario.email.trim();
    usr.email = this.usuario.email;
    usr.urlAcesso = this.utilService.getSubdominio();

    this.usuarioService.reenviarEmail(usr).subscribe(
      () => {
        $('#modalEmailAtivacao').modal('toggle');
        this.utilService.showSuccess("Se você ainda não ativou a sua conta, você vai receber um e-mail com as orientações para ativá-la");
        this.errorMessage = null;
        this.emailSent = true;
      },
      err => {
        // antes retornava a mensagem de erro especifica mas devido a REM-2769, por medidas de segurança foram removidos os retornos especificos dos erros
        $('#modalEmailAtivacao').modal('toggle');
        this.utilService.showSuccess("Se você ainda não ativou a sua conta, você vai receber um e-mail com as orientações para ativá-la");
        this.errorMessage = null;
        this.emailSent = true;
      }
    );
  }

  resetForm() {
    this.errorMessage = null;
    this.emailSent = false;
  }

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }
}
